import React, {useState, useEffect} from 'react';
import '../css/WarrantieTable.css';
import WarrantiesAdulte from './WarrantiesAdulte';
import WarrantiesMineur from './WarrantiesMineur';
import Modal from '../hooks/Modal';
import WarrantieForm from '../forms/WarrantieForm';


function WarrantieTableExample() {
    const [activeTab, setActiveTab] = useState('adulte');
    const [showModal, setShowModal] = useState(false);
    const [userType, setUserType] = useState(null);

  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  const handleAddWarrantie = () => {
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  useEffect(() => {
      // Récupérer le type d'utilisateur depuis le localStorage
      const user = JSON.parse(localStorage.getItem('user'));
      if (user) {
          setUserType(user.type);
      }
  }, []);

  return (
    
    <div className="container mx-auto p-4">
    <div className="flex justify-between">
      <div className="tabs">
        <button
          className={`tab ${activeTab === 'adulte' ? 'active' : ''}`}
          onClick={() => handleTabChange('adulte')}
        >
          Adulte
          <span className="tab-tooltip">Voir les garanties pour les adultes</span>
        </button>
        <button
          className={`tab ${activeTab === 'mineur' ? 'active' : ''}`}
          onClick={() => handleTabChange('mineur')}
        >
          Mineur
          <span className="tab-tooltip">Voir les garanties pour les mineurs</span> 
        </button>
      </div>
      {userType === 'admin' && (
      <button className="btn-primary" onClick={handleAddWarrantie}>
        Ajouter un warrantie
      </button>
      )}
    </div>
    {activeTab === 'adulte' ? <WarrantiesAdulte /> : <WarrantiesMineur />}
    {showModal && (
      <Modal onClose={handleCloseModal}>
        <WarrantieForm />
      </Modal>
    )}
  </div>
  )
}

export default WarrantieTableExample